import React from 'react';

import { IconProps } from '../../../DefaultIcon';

export function EmployeeIcon({ className }: IconProps) {
  return (
    <svg
      width="71"
      height="74"
      viewBox="0 0 71 74"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_812_675)">
        <path
          d="M50.8309 41.7927C46.4397 44.7323 41.1804 46.4704 35.5126 46.4704C29.8449 46.4704 24.5601 44.7323 20.1944 41.7927C9.47166 46.905 1.63383 57.1039 0.0254144 69.3478C-0.28095 71.8273 1.63383 74 4.13581 74H66.864C69.3659 74 71.2807 71.8273 70.9744 69.3478C69.3915 57.1039 61.5536 46.9305 50.8309 41.7927Z"
          fill="#00416B"
        />
        <path
          d="M56.065 20.0145C56.0139 14.6978 53.9204 9.68774 50.1419 5.93022C46.3379 2.12159 41.2574 0 35.8705 0C30.4835 0 25.403 2.09603 21.5734 5.93022C17.7694 9.73886 15.6504 14.8256 15.6504 20.219C15.6504 25.6124 17.7439 30.6991 21.5734 34.5078C25.3009 38.2397 30.2282 40.3102 35.462 40.4124H35.8449C41.2318 40.4124 46.3124 38.3164 50.1164 34.4822L50.8057 33.7921L47.691 30.6736L47.0017 31.3637C44.0146 34.3544 40.0574 35.9903 35.8194 35.9903C31.5814 35.9903 27.6241 34.3544 24.6371 31.3637C21.65 28.3731 20.0161 24.4111 20.0161 20.1679C20.0161 15.9247 21.65 11.9627 24.6371 8.97202C27.6241 5.98135 31.5814 4.34542 35.8194 4.34542C40.0574 4.34542 44.0146 5.98135 47.0017 8.97202C49.4526 11.4259 51.01 14.5699 51.4695 17.9696H48.1761C47.7421 15.439 46.5422 13.1385 44.704 11.2981C42.3296 8.9209 39.1639 7.61727 35.8194 7.61727C32.4749 7.61727 29.3091 8.9209 26.9348 11.2981C24.5605 13.6753 23.2584 16.8193 23.2584 20.1679C23.2584 23.5164 24.5605 26.686 26.9348 29.0376C29.3091 31.3893 32.3217 32.6674 35.5896 32.7185H35.8194C39.1639 32.7185 42.3296 31.4149 44.704 29.0376L45.3933 28.3475L42.3041 25.2546L41.6148 25.9447C40.083 27.4784 38.015 28.3475 35.8449 28.3475C33.6748 28.3475 31.6069 27.504 30.0751 25.9447C29.0538 24.9478 28.3645 23.6953 27.9816 22.3661H56.0395V19.9889M35.8449 17.9952H27.9816C28.3645 16.666 29.0538 15.439 30.0751 14.4166C31.6069 12.8829 33.6748 12.0394 35.8449 12.0394C38.015 12.0394 40.083 12.8829 41.6148 14.4166C42.636 15.439 43.3253 16.666 43.7083 17.9952H35.8449Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_812_675">
          <rect width="71" height="74" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
